/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Row_Rules_BodyInputs */



/**
* | output |
* | --- |
* | "Decide what earns XP, from messages and replies to voice, streaming and reactions." |
*
* @param {Products_Row_Rules_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_row_rules_body = /** @type {((inputs?: Products_Row_Rules_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Row_Rules_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Решайте, за что начисляется XP: от сообщений и ответов до голоса, трансляций и реакций.")
	return /** @type {LocalizedString} */ ("Decide what earns XP, from messages and replies to voice, streaming and reactions.")
});